import { cva } from "@-/com.npmjs.cva";
import type { MorphemeGlyphTileStage } from "@-/dev.improve.haniverse.lib.morpheme.stage";

// Familiarity treatment — a very slight wash of the shared warm mastery ramp
// (`--color-stage-*`, same tokens as the stats screen) paired with a subtle,
// 30%-opacity border in the same stage color, deepening with mastery. The
// background stays subtle so the glyph stays legible while the border reads as
// a clear stage indicator; the stage tokens already flip hue for dark mode.
//
// Unadded tiles use `bg-surface` (pure white in light mode) rather than the
// page's warm `bg-background`, so they stay white on search results / levels
// surfaces instead of picking up the beige page wash.
//
// Exported so the deck's card-detail tiles (`CardDetailsTileUi`) can paint
// the same review-stage treatment as the morpheme glyph tiles.
export const MORPHEME_STAGE_BACKGROUND_CLASSES: Record<MorphemeGlyphTileStage, string> = {
  familiar: "border-solid border-stage-familiar/30 bg-stage-familiar/10",
  mastered: "border-solid border-stage-mastered/30 bg-stage-mastered/10",
  new: "border-solid border-stage-new/30 bg-stage-new/10",
  proficient: "border-solid border-stage-proficient/30 bg-stage-proficient/10",
  unadded: "bg-surface",
};

export const morphemeGlyphTileVariants = cva({
  base: "flex aspect-square h-auto w-full shrink flex-col items-center justify-center rounded-xs border bg-surface p-0",
  defaultVariants: {
    stage: "unadded",
  },
  variants: {
    completion: {
      completed: "border-solid border-emerald-500 dark:border-emerald-600",
      loading: "animate-pulse border-border",
      "needs-description": "border-solid border-amber-400/70 dark:border-amber-800/60",
      "needs-review": "border-dashed border-emerald-500 dark:border-emerald-600",
      none: "border-solid border-zinc-300/80 dark:border-zinc-600/70",
    },
    stage: MORPHEME_STAGE_BACKGROUND_CLASSES,
  },
});
